module.exports = __webpack_public_path__ + "assets/Government.2855cd68.svg";